import SEOHead from '@/components/feature/SEOHead';
import Layout from '@/components/feature/Layout';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { categories, videos, type VideoItem } from '@/mocks/videos';

const categorySchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '日韩在线分类浏览 - 日韩国产在线与日韩激情在线高清专区',
    description: '日韩在线分类浏览页面，提供日韩国产在线、日韩激情在线、日韩精品在线、日韩久久在线、日韩高清在线五大分类内容。',
    url: 'https://rihanzaixian.com/category',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://rihanzaixian.com/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '分类浏览',
        item: 'https://rihanzaixian.com/category',
      },
    ],
  },
];

export default function CategoryPage() {
  const [searchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'guochan';
  const [activeTab, setActiveTab] = useState(initialTab);
  const [filteredVideos, setFilteredVideos] = useState<VideoItem[]>([]);

  useEffect(() => {
    setFilteredVideos(videos.filter((v) => v.category === activeTab));
  }, [activeTab]);

  const activeCategory = categories.find((c) => c.slug === activeTab);

  return (
    <>
      <SEOHead
        title={`日韩在线 - ${activeCategory?.name || '分类浏览'} | 日韩精品在线久久免费观看全集`}
        description={`日韩在线${activeCategory?.name || '分类浏览'}专区，提供最新日韩剧、综艺、动漫高清视频在线观看。日韩国产在线与日韩激情在线高清一区二区，不缓冲全集体验。`}
        keywords={`日韩在线,${activeCategory?.name || '分类'},日韩高清在线,日韩剧在线观看,日韩综艺在线,日韩动漫在线`}
        canonicalUrl={`https://rihanzaixian.com/category?tab=${activeTab}`}
        schemaData={categorySchema}
      />

      <Layout>
        <div className="pt-20 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
            <nav className="text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <a href="/" className="hover:text-primary-600 transition-colors cursor-pointer">首页</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-800 font-medium">分类浏览</span>
            </nav>

            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              内容分类浏览
            </h1>
            <p className="text-sm text-foreground-600 mb-8">
              选择分区浏览日韩国产在线、日韩激情在线、日韩精品在线等全部分类内容
            </p>

            <div className="flex flex-wrap gap-3 mb-10">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveTab(cat.slug)}
                  className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeTab === cat.slug
                      ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
              {filteredVideos.map((video) => (
                <a
                  key={video.id}
                  href={`/article/${video.id}`}
                  className="group cursor-pointer"
                >
                  <div className="relative rounded-lg overflow-hidden aspect-video mb-3">
                    <img
                      src={video.image}
                      alt={video.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute top-2 right-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-bold px-2 py-1 rounded">
                      {video.rating}
                    </div>
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-4xl text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                    </div>
                  </div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                    <span>{video.region}</span>
                    <span>·</span>
                    <span>{video.year}</span>
                    <span>·</span>
                    <span>{video.views}次播放</span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}